<template>
  <collapse title="Cantidad a Pagar">
    <div class="mb-3">
      <div
        v-for="(item, idx) in visibleItems"
        :key="item.id || idx"
        class="mb-3 "
      >
        <custom-callout
          border-color="#b5c3bc"
          class="mb-4 custom-callout contracts-box"
          :has-toggle="false"
        >
          <div class="row pt-2">
            <div class="col-12 col-md-3 d-flex flex-column my-2">
              <span class="color-gray-6 font-14">Proveedor</span>
              <span class="font-16 font-weight-bold">
                {{ item.providerName | empty }}
              </span>
            </div>

            <div
              v-if="!isRenewal"
              class="col-12 col-md-3 d-flex flex-column my-2"
            >
              <span class="color-gray-6 font-14">Número de Contrato</span>
              <span class="font-16 font-weight-bold">
                {{ item.contractNumber | empty }}
              </span>
            </div>

            <div
              v-if="!isRenewal"
              class="col-12 col-md-3 d-flex flex-column my-2"
            >
              <span class="color-gray-6 font-14">
                Cuantía del Contrato Vigente
              </span>
              <span class="font-16 font-weight-bold">
                {{ item.amount | price }}
              </span>
            </div>

            <div
              v-if="!isRenewal"
              class="col-12 col-md-3 d-flex flex-column my-2"
            >
              <span class="color-gray-6 font-14">Enmiendas Otorgadas</span>
              <span class="font-16 font-weight-bold">{{ item.quantity }}</span>
            </div>
          </div>

          <div class="row mt-2">
            <div
              v-if="!isRenewal && !isAmendment"
              class="col-12 col-md-3 d-flex flex-column my-2"
            >
              <span class="color-gray-6 font-14">Enmienda</span>
              <span class="font-16 font-weight-bold">
                {{ item.lastAmendmentCode | empty }}
              </span>
            </div>
            <div class="col-12 col-md-3 d-flex flex-column my-2">
              <span class="color-gray-6 font-14">Monto Asignado</span>

              <template v-if="!isReadOnly">
                <validation-provider
                  v-if="isAmountRequired"
                  v-slot="{ errors }"
                  rules="required|greaterThanZero"
                >
                  <money
                    v-model.lazy.number="item.paymentAmount"
                    v-bind="moneyOptions"
                    class="form-control"
                    :class="{ 'was-Invalidated': errors[0] }"
                  />
                  <error
                    v-if="errors[0]"
                    :message="errors[0]"
                    variant="no-border"
                  />
                </validation-provider>
                <money
                  v-else
                  v-model.lazy.number="item.paymentAmount"
                  v-bind="moneyOptions"
                  class="form-control"
                />
              </template>

              <template v-else>
                <label class="data-label">
                  {{ item.paymentAmount | price }}
                </label>
              </template>
            </div>

            <div
              v-if="!isRenewal"
              class="col-12 col-md-3 d-flex flex-column my-2 d-flex "
            >
              <div class="d-flex flex-column">
                <span class="color-gray-6 font-14">Total del Contrato</span>
                <span class="font-16 font-weight-bold text-success">
                  {{ (item.amount + item.paymentAmount) | price }}
                </span>
              </div>
            </div>
          </div>
        </custom-callout>
      </div>

      <div v-if="showToggle" class="text-center">
        <action-button
          variant="outline-success custom-view-more actionButton rounded-pill"
          @click="expanded = !expanded"
        >
          {{ expanded ? 'Ver menos' : 'Ver más' }}
          <i
            class="ml-1"
            :class="expanded ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"
          />
        </action-button>
      </div>
    </div>
  </collapse>
</template>

<script>
import { moneyOptions } from '@/utils/objUtils';
import { ValidationProvider } from 'vee-validate';
import { Money } from 'v-money';
import Error from 'custom-error';
import CustomCallout from 'custom-callout';
import Collapse from '@/components/common/SimpleCollapse.vue';
import ActionButton from 'ActionButton';

export default {
  name: 'PaymentAmount',
  components: {
    ValidationProvider,
    Error,
    Money,
    CustomCallout,
    Collapse,
    ActionButton,
  },
  props: {
    value: { type: Array, default: () => [] },
    isReadOnly: { type: Boolean, default: false },
    isAmountRequired: { type: Boolean, default: true },
    collapsedCount: { type: Number, default: 3 },
    isAmendment: { type: Boolean, default: false },
    isRenewal: { type: Boolean, default: false },
  },
  data() {
    return {
      moneyOptions,
      expanded: false,
    };
  },
  computed: {
    model: {
      get() {
        return this.value || [];
      },
      set(v) {
        this.$emit('input', v);
      },
    },

    visibleItems() {
      return (this.expanded
        ? this.model
        : this.model.slice(0, this.collapsedCount)
      ).sort((a, b) =>
        (a.providerName || '').localeCompare(b.providerName || '')
      );
    },

    showToggle() {
      return (this.model.length || 0) >= this.collapsedCount;
    },
  },
};
</script>

<style scoped>
.text-success {
  color: #19a974;
}
.was-Invalidated {
  border-color: #dc3545;
}
.contracts-box::v-deep .bg-secondary-3,
.contracts-box::v-deep .bg-container {
  background-color: #fff !important;
}
</style>
